import { Col, Row } from 'antd';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { sanitizeHtml } from '../common/utils/htmlUtils';
import { HeaderLogo } from '../components/Logo';
import { CustomLoaderButton } from '../components/buttons/buttons';
import { FormItemInlineCheckbox } from '../components/forms/checkable';
import { assertTrueRule } from '../components/forms/formValidationRules';
import { NoLabelForm, SubmitButton } from '../components/forms/forms';
import {
  Scrollbars,
  VerticalTrackTypes,
} from '../components/layout/Scrollbars';
import {
  Flex1,
  FlexCol,
  ThreeLines,
} from '../components/layout/layoutElements';
import { useTermsOfServicePageStyles } from './TermsOfServicePage.styles';

export default function TermsOfServicePage({ onAccept, onCancel, content }) {
  const { styles } = useTermsOfServicePageStyles();
  const cleanHtml = sanitizeHtml(content);

  return (
    <div className={styles.termsOfServicePage}>
      <FlexCol className={styles.container}>
        <HeaderLogo size="sm" className={styles.logo} />
        <Flex1>
          <Scrollbars
            vertical={VerticalTrackTypes.INSIDE}
            className={styles.threeLinesAndScrollbar}
          >
            <div className={styles.content}>
              <div
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: cleanHtml }}
              />
              <p>
                <FormattedMessage id="termsOfService.suffix" />
              </p>
            </div>
          </Scrollbars>
        </Flex1>
        <ThreeLines
          className={classNames(
            styles.threeLinesAndScrollbar,
            styles.threeLines
          )}
        />
        <NoLabelForm onSubmit={onAccept}>
          <Row justify="space-between" align="middle">
            <Col
              className={classNames('no-margin-form-items', styles.checkbox)}
            >
              <FormItemInlineCheckbox
                labelId="termsOfService.accept"
                name="accept"
                rules={[assertTrueRule]}
              />
            </Col>
            <Col className={styles.buttons}>
              <CustomLoaderButton size="middle" onClick={onCancel}>
                <FormattedMessage id="buttons.cancel" />
              </CustomLoaderButton>
              <SubmitButton size="middle" type="primary">
                <FormattedMessage id="buttons.continue" />
              </SubmitButton>
            </Col>
          </Row>
        </NoLabelForm>
      </FlexCol>
    </div>
  );
}
